import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

function ShopSuccess() {
  const [searchParams] = useSearchParams();
  const [copied, setCopied] = useState(false);

  const key     = searchParams.get('key') || '–';
  const email   = searchParams.get('email') || '';
  const plan    = searchParams.get('plan') || '';
  const expires = searchParams.get('expires') || '';

  const expiresFormatted = expires
    ? new Date(expires).toLocaleDateString('de-DE', { day: '2-digit', month: 'long', year: 'numeric' })
    : '–';

  const copyKey = () => {
    navigator.clipboard.writeText(key).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="shop-success">
      <div className="success-icon">🎉</div>
      <h1 className="success-title">Vielen Dank!</h1>
      <p className="success-sub">Deine Bestellung war erfolgreich.<br />Hier ist dein Lizenzschlüssel:</p>

      <div className="license-display">
        <div className="license-display-label">Dein Lizenzschlüssel</div>
        <div className="license-display-key" onClick={copyKey} title="Klicken zum Kopieren">
          {key}
        </div>
        <button
          className={`btn ${copied ? 'btn-gradient' : 'btn-secondary'}`}
          style={{ margin: '0 auto' }}
          onClick={copyKey}
        >
          {copied ? '✓ Kopiert!' : '📋 Kopieren'}
        </button>
      </div>

      <div className="card" style={{ marginBottom: '20px', textAlign: 'left' }}>
        <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
          <tbody>
            {[
              { label: 'Plan', value: plan },
              { label: 'Gültig bis', value: expiresFormatted },
              { label: 'E-Mail', value: email },
            ].map(({ label, value }) => (
              <tr key={label}>
                <td style={{ padding: '7px 0', color: 'var(--text-muted)', borderBottom: '1px solid var(--border)' }}>{label}</td>
                <td style={{ padding: '7px 0', fontWeight: 600, textAlign: 'right', borderBottom: '1px solid var(--border)' }}>{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="success-steps">
        <h3>So aktivierst du deine Lizenz:</h3>
        {[
          'Öffne Familytool',
          <span>Gehe zu <strong>Einstellungen → Lizenz</strong></span>,
          <span>Gib den Schlüssel ein und klicke <strong>"Prüfen"</strong></span>,
        ].map((step, i) => (
          <div key={i} className="step-item">
            <div className="step-num">{i + 1}</div>
            <span style={{ color: 'var(--text-muted)', fontSize: '14px' }}>{step}</span>
          </div>
        ))}
      </div>

      <p style={{ fontSize: '13px', color: 'var(--text-dim)', marginBottom: '20px' }}>
        Der Schlüssel wurde auch an deine E-Mail gesendet.
      </p>

      <Link to="/shop" className="btn btn-secondary">← Zurück zum Shop</Link>
    </div>
  );
}

export default ShopSuccess;
